import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogFooter,
  DialogClose,
} from "@/components/ui/dialog"
import { Button } from "@/components/button"
import { toast } from "sonner"
import useDeleteFlashcard from "@/modules/flashcards/queries/use-delete-flashcard"
import { useDeleteFlashcardModal } from "../../stores/use-delete-flashcard-modal-store"

const DeleteFlashcardModal = () => {
  const { isOpen, flashcardId, closeModal } = useDeleteFlashcardModal()
  const { isPending, mutateAsync } = useDeleteFlashcard()

  const handleOnClose = () => {
    if (isPending) return
    closeModal()
  }

  const handleOnDelete = async () => {
    try {
      await mutateAsync({ flashcardId })
      toast.success("Flashcard eliminada correctamente.")
    } catch {
      toast.error("Ha ocurrido un error al eliminar la flashcard.")
    } finally {
      closeModal()
    }
  }

  return (
    <Dialog open={isOpen} onOpenChange={handleOnClose}>
      <DialogContent className="w-fit min-w-[320px]">
        <DialogHeader className="flex items-start">
          <DialogTitle>¿Eliminar flashcard?</DialogTitle>
          <DialogDescription>
            <p className="mt-2 text-left">Se eliminará tu progreso.</p>
            <p>Esta acción es irreversible.</p>
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="flex flex-row items-center justify-end gap-1">
          <DialogClose asChild>
            <Button type="button" className="bg-gray-300 text-black" disabled={isPending}>
              Cancelar
            </Button>
          </DialogClose>

          <Button type="button" onClick={handleOnDelete} loading={isPending} disabled={isPending}>
            Eliminar
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}

export default DeleteFlashcardModal
